module.exports = __webpack_public_path__ + "static/img/5fdce300df3cc9a182a5087a9f35b421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_04.png
// module id = HK5y
// module chunks = 1